const floatingSideButton = {
  getSettings: componentSettings => ({
    ...componentSettings,
    modifier: 'button--floating-side'
  })
};

export default floatingSideButton;
